import { render, staticRenderFns } from "./calcpointlist.vue?vue&type=template&id=dc8b816a&scoped=true"
import script from "./calcpointlist.vue?vue&type=script&lang=js"
export * from "./calcpointlist.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc8b816a",
  null
  
)

export default component.exports